import React, { Component } from 'react';
import logo from './resources/LogoHorizontal.jpg';
import Home from './home/home';
import Interview from './interviews/interviews';
import Ideas from './ideas/ideas';
import firebase from './app/firebaseConnection';
import './styles/App.css';

class App extends Component {

  constructor(props) {
    super();
    this.interviewActive = this.interviewActive.bind(this);
    this.generalActive = this.generalActive.bind(this);
    this.ideasActive = this.ideasActive.bind(this);
    this.state = {
      General : true,
      Interview: false,
      Ideas: false
    }
  }

  generalActive() {
    this.setState({General: true, Interview: false, Ideas: false})
  }

  interviewActive() {
    this.setState({General: false, Interview: true, Ideas: false})
  }

  ideasActive() {
    this.setState({General: false, Interview: false, Ideas: true})
  }

  render() {
    const GeneralComponent = this.state.General;
    const InterviewComponent = this.state.Interview;
    const IdeasComponent = this.state.Ideas;
    let component = null;
    if (GeneralComponent) {
      component = <Home/>
    } else if (InterviewComponent){
      component = <Interview/>
    } else if (IdeasComponent) {
      component = <Ideas/>
    }
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo"/>
          <a className="tabsRef" onClick={this.ideasActive}>Ideas de negocios</a>
          <a className="tabsRef" onClick={this.interviewActive}>Entrevistas</a>
          <a className="tabsRef" onClick={this.generalActive}>General</a>
        </header>
        {component}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js